module.exports = __webpack_public_path__ + "static/media/global_fund.70e1351a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_fund.png
// module id = 994
// module chunks = 0